import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/Thanks'
import useLocalStorage from 'hooks/useLocalStorage'

const Thanks: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refAwsFargateLpContactPage')
  return (
    <>
      {fromCorrectFormPage ? (
        <CustomHead
          keyword={'AWS Fargate サーバーレス コンテナ 自動スケーリング'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/services/awsfargate/thanks/'}
          title="送信完了 AWS Fargate | サービス | Aitria（アイトリア）"
          description="AWS Fargate導入支援で、サーバーレスなコンテナ環境を提供します。自動スケーリングにより、迅速なデプロイと効率的なリソース管理を実現します。"
        />
      ) : (
        <></>
      )}
      <Template />
    </>
  )
}

export default Thanks
